import React from 'react';
import PublicNavbar from '../../components/Navigation/PublicNavbar';
import { Brain, Video, BarChart3, Target, Users, Database } from 'lucide-react';

const ServiciosPage: React.FC = () => {
  const services = [
    {
      icon: <Brain className="w-16 h-16" />,
      title: "IA Conversacional",
      description: "Búsqueda inteligente de jugadores usando lenguaje natural. Encuentra el talento perfecto describiendo lo que necesitas.",
      features: ["Procesamiento de lenguaje natural", "Búsqueda semántica avanzada", "Filtros inteligentes automáticos"]
    },
    {
      icon: <Video className="w-16 h-16" />,
      title: "Análisis de Video",
      description: "Análisis automático de videos de partidos con Deep Learning para extraer métricas físicas y tácticas.",
      features: ["Detección automática de jugadores", "Métricas de velocidad y distancia", "Análisis de movimiento YOLO v8"]
    },
    {
      icon: <BarChart3 className="w-16 h-16" />,
      title: "Analytics Avanzado",
      description: "Machine Learning y análisis predictivo para evaluar rendimiento y potencial de jugadores.",
      features: ["Clustering de jugadores similares", "Análisis PCA", "Predicciones de rendimiento"]
    },
    {
      icon: <Target className="w-16 h-16" />,
      title: "Scouting Profesional",
      description: "Herramientas completas para directores deportivos y scouts profesionales.",
      features: ["Base de datos global", "Informes detallados", "Seguimiento de evolución"]
    },
    {
      icon: <Users className="w-16 h-16" />,
      title: "Gestión de Plantilla",
      description: "Organización y planificación estratégica de plantillas deportivas.",
      features: ["Análisis de contratos", "Planificación de fichajes", "Gestión de cedidos"]
    },
    {
      icon: <Database className="w-16 h-16" />,
      title: "Base de Datos Global",
      description: "Acceso a miles de jugadores de las principales ligas mundiales con datos actualizados.",
      features: ["Datos de Transfermarkt", "Estadísticas FBRef", "Actualizaciones en tiempo real"]
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-900 via-blue-800 to-blue-700">
      <PublicNavbar />
      
      <div className="pt-20 px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="max-w-7xl mx-auto text-center py-20">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-8">
            Nuestros <span className="text-blue-300">Servicios</span>
          </h1>
          <p className="text-xl text-blue-100 max-w-4xl mx-auto leading-relaxed">
            Tecnología de vanguardia para revolucionar el scouting deportivo con 
            inteligencia artificial y análisis avanzado
          </p>
        </div>

        {/* Services Grid */}
        <div className="max-w-7xl mx-auto pb-20">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-white/10 backdrop-blur-md rounded-3xl p-8 border border-white/20 hover:bg-white/20 transition-all duration-300 transform hover:scale-105"
              >
                <div className="flex justify-center mb-6 text-blue-300">
                  {service.icon}
                </div>
                <h3 className="text-2xl font-bold text-white mb-4 text-center">
                  {service.title}
                </h3>
                <p className="text-blue-100 mb-6 leading-relaxed">
                  {service.description}
                </p>
                <ul className="space-y-2">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-blue-200">
                      <div className="w-2 h-2 bg-blue-400 rounded-full mr-3"></div>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Section */}
        <div className="max-w-4xl mx-auto text-center pb-20">
          <div className="bg-white/10 backdrop-blur-md rounded-3xl p-12 border border-white/20">
            <h3 className="text-3xl font-bold text-white mb-6">
              ¿Listo para transformar tu scouting?
            </h3>
            <p className="text-blue-100 text-lg mb-8">
              Descubre cómo nuestros servicios pueden potenciar tu trabajo deportivo
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button 
                onClick={() => window.location.href = '/contacto'}
                className="px-8 py-4 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-xl transition-all duration-200 transform hover:scale-105"
              >
                Solicitar Demo
              </button>
              <button 
                onClick={() => window.location.href = '/contacto'}
                className="px-8 py-4 bg-white/20 hover:bg-white/30 text-white font-semibold rounded-xl transition-all duration-200 transform hover:scale-105"
              >
                Consultar Precios
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiciosPage;
